import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'grab-ui';
import cx from 'classnames';
import styles from './status-progress-bar.less';
import { STATUS_STAGE } from '../../constants/new-order-status';

const PickUpBox = ({ isActive }) => {
  const classNames = cx({
    [styles.activeIcon]: isActive,
    [styles.inActiveIcon]: !isActive,
  });
  return (
    <svg
      className={classNames}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
        d="M1.86719 3.9668h10.2667v8.55556H1.86719z"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M1.86719 3.96706 3.5783 1.40039h6.8444l1.7112 2.56667"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.71094 7.95898 6.99983 6.24787 5.28871 7.95898M7 6.5338v3.7074"
      />
    </svg>
  );
};

PickUpBox.propTypes = {
  isActive: PropTypes.bool,
};

PickUpBox.defaultProps = {
  isActive: false,
};

const DropOffBox = ({ isActive }) => {
  const classNames = cx({
    [styles.activeIcon]: isActive,
    [styles.inActiveIcon]: !isActive,
  });

  return (
    <svg
      className={classNames}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
        d="M1.86719 3.9668h10.2667v8.55556H1.86719z"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M1.86719 3.96706 3.5783 1.40039h6.8444l1.7112 2.56667"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5.29102 8.57411 1.71111 1.71109 1.71111-1.71109M7.00195 5.99962v3.70741"
      />
    </svg>
  );
};

DropOffBox.propTypes = {
  isActive: PropTypes.bool,
};

DropOffBox.defaultProps = {
  isActive: false,
};

const PickUpBike = ({ isActive }) => {
  const classNames = cx({
    [styles.activeIcon]: isActive,
    [styles.inActiveIcon]: !isActive,
  });

  return (
    <svg
      className={classNames}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      fill="none"
    >
      <g>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M2.94786 9.33544H1.125s.72459-4.52892 4.60915-4.52892c3.88456 0 4.57715 4.52892 4.57715 4.52892H8.17499"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          d="M2.94786 9.33544H1.125s.72459-4.52892 4.60915-4.52892c3.88456 0 4.57715 4.52892 4.57715 4.52892H8.17499"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          stroke="currentColor"
          d="M5.73381 11.6787c1.34804 0 2.44084-1.0491 2.44084-2.34318 0-1.29412-1.0928-2.34321-2.44084-2.34321-1.34804 0-2.44084 1.04909-2.44084 2.34321 0 1.29408 1.0928 2.34318 2.44084 2.34318ZM14.683 11.6787c1.3481 0 2.4409-1.0491 2.4409-2.34318 0-1.29412-1.0928-2.34321-2.4409-2.34321-1.348 0-2.4408 1.04909-2.4408 2.34321 0 1.29408 1.0928 2.34318 2.4408 2.34318Z"
          clipRule="evenodd"
          strokeLinejoin="round"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.07282 3.33063h5.47469M10.6152.890205h1.6347M12.463.890625s1.5582 2.278515 1.8893 3.916385l.331 1.63788H9.47656"
        />
      </g>
    </svg>
  );
};

PickUpBike.propTypes = {
  isActive: PropTypes.bool,
};

PickUpBike.defaultProps = {
  isActive: false,
};

const StatusProgressBar = ({ status }) => {
  const stage = status in STATUS_STAGE ? STATUS_STAGE[status] : 0;

  return (
    <div className={styles.container}>
      <PickUpBike isActive={stage >= 1} />

      <Progress
        percent={stage > 1 ? 100 : 0}
        status={stage > 2 ? 'normal' : 'active'}
        showInfo={false}
        strokeWidth={4}
      />

      <PickUpBox isActive={stage >= 3} />

      <Progress
        percent={stage > 3 ? 100 : 0}
        status={stage > 4 ? 'normal' : 'active'}
        showInfo={false}
        strokeWidth={4}
      />

      <DropOffBox isActive={stage >= 5} />
    </div>
  );
};

StatusProgressBar.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusProgressBar;
